// Configuración centralizada de Business OS Equipo Alerce
export const CONFIG = {
  APP_NAME: 'Business OS Equipo Alerce',
  VERSION: '0.1.0',
  OWNER: 'Martín',
  OWNER_EMAIL: 'martin.batarev@gmail.com',
  COMPANY_NAME: 'Equipo Alerce',
  COMPANY_EMAIL: 'contacto@equipoalerce.com',
  COMPANY_PHONE: '+54 9 11 1234-5678',
  SUPABASE_URL: (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_URL) || (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_URL) || '',
  SUPABASE_ANON_KEY: (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_ANON_KEY) || (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_ANON_KEY) || '',
  MONTHLY_HOURS_GOAL: 160
};
